var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 82,
    height: 82,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_91_32)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.972 22.3301L42.1419 43.1366L61.252 34.5301L52.5858 64.5037L31.362 65.6403L17.332 40.6303L31.972 22.3303M33.223 11.0001L12.569 36.8178L10.0004 40.0298L12.0115 43.6159L26.0415 68.6259L27.8977 71.9357L31.6887 71.7331L52.9125 70.5965L57.2421 70.3654L58.4454 66.2002L67.1117 36.2266L70.7764 23.5527L58.7454 28.9712L45.0277 35.1474L37.4528 19.6522L33.223 11.0001Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_91_32"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 61,
    height: 61,
    fill: "white",
    transform: "translate(10 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.3282f3aab32c74e2983cbf9cfec6b205.svg";
export { ForwardRef as ReactComponent };